module.exports = __webpack_public_path__ + "static/media/rebirth_sample_7.4cccdadf.jpg";